
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexkSfZkeRxJG4BbvGERsSS5UobgxMjfO_45MMkJjXlp8Q5sMeta } from "/tmp/build_2f948bb8/pages/app/me/index.vue?macro=true";
import { default as meDQZ0e_JU7gviYiuEkZMZbF0HR5h2fFBwZXQ_45QJCbHnQMeta } from "/tmp/build_2f948bb8/pages/app/me.vue?macro=true";
import { default as mapAJBgW9woa3YKMKjy48MC3HODAY4NnJOJ1fscFCBK4oIMeta } from "/tmp/build_2f948bb8/pages/app/map.vue?macro=true";
import { default as postdobwtjK6dfaucFCXnanv6HXDlUzR_JfbiH3Lwzy1VVQMeta } from "/tmp/build_2f948bb8/pages/app/feed/post.vue?macro=true";
import { default as indexMeoJaXEdsiIy3foYHYSriZlDKr8Z1Lasa99vlYCCg_45MMeta } from "/tmp/build_2f948bb8/pages/app/feed/index.vue?macro=true";
import { default as _91type_93JpbgpSlNmyGHTYuZfFnz1wSVFPM9_dba3fhzHIWXgScMeta } from "/tmp/build_2f948bb8/pages/app/feed/[type].vue?macro=true";
import { default as feed3w8LOPdd7UI8gNsuZ1EW1AzN0CiW7TesRcxU1nLinzsMeta } from "/tmp/build_2f948bb8/pages/app/feed.vue?macro=true";
import { default as index4BthM0agDeEyhaYVLyRlGJq1g4Qugg6TzZKt8_kxMcUMeta } from "/tmp/build_2f948bb8/pages/app/index.vue?macro=true";
import { default as eula0fiaT_dR67au3vheXskYFfCDLlaT0gmwls77o0A7vOAMeta } from "/tmp/build_2f948bb8/pages/main/eula.vue?macro=true";
import { default as indexURWwUH4Sv2DqrF6JzMbyIBWXdiFflDJfyATKm52oBqQMeta } from "/tmp/build_2f948bb8/pages/app/groups/index.vue?macro=true";
import { default as edit4WChrL2DvemL5paAiVQJ0LOft4gJSbPndRWVaGkiNJQMeta } from "/tmp/build_2f948bb8/pages/app/groups/[slug]/edit.vue?macro=true";
import { default as aboutPPuQhJJE4GXXLQm0S_rLmqSsvUwdhy_DG_05N5XdR8IMeta } from "/tmp/build_2f948bb8/pages/app/groups/[slug]/about.vue?macro=true";
import { default as indexwoTxCAmGh_sIkxEo8FqDx3VgOICtDKV_Y64EnOK2L0IMeta } from "/tmp/build_2f948bb8/pages/app/groups/[slug]/index.vue?macro=true";
import { default as eventsR2_wI8IEPK69NR_45PVWLjhX3dcrM9wZafVr5TQU2P3BsMeta } from "/tmp/build_2f948bb8/pages/app/groups/[slug]/events.vue?macro=true";
import { default as members_UybJLHKUdlHIZ_4595FhTrKjEP3eMBnv_45dy5PmgDvLywMeta } from "/tmp/build_2f948bb8/pages/app/groups/[slug]/members.vue?macro=true";
import { default as conversationssqM_Go05xA2hYkbe9pVW0f3u1Mcb6RAlFTGFkNOAVFMMeta } from "/tmp/build_2f948bb8/pages/app/groups/[slug]/conversations.vue?macro=true";
import { default as _91slug_935d_E63cJOSoEkm_FbICiYWqzsGigKdFCj7_45poEY6XGEMeta } from "/tmp/build_2f948bb8/pages/app/groups/[slug].vue?macro=true";
import { default as createfKTUPh2MVuD3rVirItrx58z_45S2gQUtBfrl69PW7RAjcMeta } from "/tmp/build_2f948bb8/pages/app/groups/create.vue?macro=true";
import { default as groups62tYVOxcrWxjQLmgUnnaPI9JroDs68UyBMO43Kzks3cMeta } from "/tmp/build_2f948bb8/pages/app/groups.vue?macro=true";
import { default as index75fgToJ3omEUAzNNCWEPLPjD8U9ep_ncMhT6JccGOckMeta } from "/tmp/build_2f948bb8/pages/app/params/index.vue?macro=true";
import { default as accountSwb5M70rVnZKudgCpuM7do6yMZIerjK6PJYfMxA3xqAMeta } from "/tmp/build_2f948bb8/pages/app/params/account.vue?macro=true";
import { default as transactionsrvmyuxO2tDrRY_45Cse_8P8dXQXcAb6AhzFlexjQOv2NAMeta } from "/tmp/build_2f948bb8/pages/app/params/transactions.vue?macro=true";
import { default as paramshGLAPmDqQmsBqQ3TXyGBOIDoEkFinuE_45dMo2FAUyHdMMeta } from "/tmp/build_2f948bb8/pages/app/params.vue?macro=true";
import { default as indexI8kPQwVb_45WMBFyfPTeB5FY4rlb3U7M5E_GBcLzWCjSAMeta } from "/tmp/build_2f948bb8/pages/main/index.vue?macro=true";
import { default as press6w1LKVKQvwG0GJzhE3M5JNUEbn9kb9ESha6H8wqpiroMeta } from "/tmp/build_2f948bb8/pages/main/press.vue?macro=true";
import { default as codes7xWT9EkaAWruLk_45T8RfOkYUVylVMZrlxf14Q_bGvTFUMeta } from "/tmp/build_2f948bb8/pages/admin/codes.vue?macro=true";
import { default as indexJynwy786Zm3xHPUG_ImP93u6NoCd8rBOJD507JNtlX4Meta } from "/tmp/build_2f948bb8/pages/admin/index.vue?macro=true";
import { default as indexlJi_45WuxP0z9_45u_45eDD_45QEmlr_45PKGczuKkHl_edbNEbbIMeta } from "/tmp/build_2f948bb8/pages/app/hangout/index.vue?macro=true";
import { default as agendaGiA62ukj6MrRVHrunTsZQh549_45JEMWdBzMl0xtfYNrwMeta } from "/tmp/build_2f948bb8/pages/app/hangout/agenda.vue?macro=true";
import { default as meetups8vSNl2d3j1Sk4qeTb42a_45rnBcdeDpNloqcks23GrDgYMeta } from "/tmp/build_2f948bb8/pages/app/hangout/meetups.vue?macro=true";
import { default as organizeTRYUTe61IDLRNj1nSp93KSL9Sh2p0XOEfEeDBc9hswYMeta } from "/tmp/build_2f948bb8/pages/app/hangout/organize.vue?macro=true";
import { default as hangoutSz63weB1WxFmOXVUlPxHIDml2qBlxeRdbXCxbMMtndMMeta } from "/tmp/build_2f948bb8/pages/app/hangout.vue?macro=true";
import { default as chartex8ZpudX39Y35SLtnUAvb6mp70nmGaqEluxH4O_m3zMEMeta } from "/tmp/build_2f948bb8/pages/main/charte.vue?macro=true";
import { default as france2a70q2zLdh0cH_SYFo_scQBMZaiRljlrHmcX8wbawuIMeta } from "/tmp/build_2f948bb8/pages/main/france.vue?macro=true";
import { default as themes9xKmzzE_45HjIdlgtUDeNNwC1hqCUdBROSfMn4p_45oJIjAMeta } from "/tmp/build_2f948bb8/pages/admin/themes.vue?macro=true";
import { default as indexXZQvwArXY_45t4ZeNczNUUxHk_9CP_45n8SZKk8h8c9qD3kMeta } from "/tmp/build_2f948bb8/pages/app/insiders/index.vue?macro=true";
import { default as suggestionspWvtkKryw_akM385fHpgpyBK8RERBUMo4TaGd1ba9_45UMeta } from "/tmp/build_2f948bb8/pages/app/insiders/suggestions.vue?macro=true";
import { default as insidersx_45WCfSuoTMnShIxmKucXyZutgHaVzwaf8i4eMWh4fD4Meta } from "/tmp/build_2f948bb8/pages/app/insiders.vue?macro=true";
import { default as messageslIG5g5EuFxbXYDvQAix9QkmGP4GxxK4Qy5f9cORjH74Meta } from "/tmp/build_2f948bb8/pages/app/messages.vue?macro=true";
import { default as privacyS7CSltRzOze4AmxcfwLovlo3mTSfumWDIOANZrGO_7IMeta } from "/tmp/build_2f948bb8/pages/main/privacy.vue?macro=true";
import { default as trainerqihrbh1O8ViVEPiAFY8j6dA3fDJYd6_4548tgufGWpLPsMeta } from "/tmp/build_2f948bb8/pages/admin/trainer.vue?macro=true";
import { default as indexELIesie44XR2rbWaJxVomwVhX6Rm2NI_45t7JhLPRQuC8Meta } from "/tmp/build_2f948bb8/pages/app/community/index.vue?macro=true";
import { default as searchMy_45Z4QcbR3oVL5WLtOvnfaeG0IWQqZCslsTxz0wgFlcMeta } from "/tmp/build_2f948bb8/pages/app/community/search.vue?macro=true";
import { default as bestiesQAnMTV_45KRRXGSpv_45SyJzixoOdjtNFktKIsI9wRFfE2IMeta } from "/tmp/build_2f948bb8/pages/app/community/besties.vue?macro=true";
import { default as indexalJNUqT64H6SSHA2XB18vLzIWzLR758QmmuVFD7vlkAMeta } from "/tmp/build_2f948bb8/pages/app/community/[type]/index.vue?macro=true";
import { default as community8_HVM3vuTQ28W6PaPwPJMDWZg2y_450DtO_D98KWPVxJAMeta } from "/tmp/build_2f948bb8/pages/app/community.vue?macro=true";
import { default as indexM5znqnFJE5Isjojr6seM5F5hfcT5TK4jDbeFWz7JrwQMeta } from "/tmp/build_2f948bb8/pages/app/auth/index.vue?macro=true";
import { default as about0QOuf3QJVwpQkC7dakVW530m7583NzedLZIgPUrwD5gMeta } from "/tmp/build_2f948bb8/pages/app/onboarding/about.vue?macro=true";
import { default as email1_pM7rYn1IlC5FcEG7Z_451ZLTv7U6pX8Y6dDT0PAA4tAMeta } from "/tmp/build_2f948bb8/pages/app/onboarding/email.vue?macro=true";
import { default as goalsBZB6k3nQ8wpqRp6yYEAHE8eXq6FA3o0Nc5c4CW6mchMMeta } from "/tmp/build_2f948bb8/pages/app/onboarding/goals.vue?macro=true";
import { default as indexGrvS7Wqczeqluciioc3VCJo0zcRjkXgweS_j846VV8wMeta } from "/tmp/build_2f948bb8/pages/app/onboarding/index.vue?macro=true";
import { default as phonewdIzhd7HviiEfUOnSOJwnbJN9YcoqDyqA_45Ce4yk9AtgMeta } from "/tmp/build_2f948bb8/pages/app/onboarding/phone.vue?macro=true";
import { default as groupsl12vBp302Z1aghwe8grMo4qZEyBLVd3c8JBRHVBkkHEMeta } from "/tmp/build_2f948bb8/pages/app/onboarding/groups.vue?macro=true";
import { default as searchYoTg8IcxUr_45cAN67ljJ1HeLMrpmG1N5dWieh12Owxa0Meta } from "/tmp/build_2f948bb8/pages/app/onboarding/search.vue?macro=true";
import { default as charterAoR7FWOZAwIbZNcaJL2DkM6eMtP5kKE5Wo28GoL_bDkMeta } from "/tmp/build_2f948bb8/pages/app/onboarding/charter.vue?macro=true";
import { default as loadingf4G8A_HzxAWkcJI6wpukPAFeiLwOWPxy4h32dLL_45mgcMeta } from "/tmp/build_2f948bb8/pages/app/onboarding/loading.vue?macro=true";
import { default as profile_45fBuGy0bmhCXHHSHMTiQAZ3PKel9e0TVQ325LOt8TwgMeta } from "/tmp/build_2f948bb8/pages/app/onboarding/profile.vue?macro=true";
import { default as identity_MGu6dqh7w9_45E4EHGuDolhvilrNqbGnLBfiRi7bD_45AAMeta } from "/tmp/build_2f948bb8/pages/app/onboarding/identity.vue?macro=true";
import { default as profilesB38HJSUwVgbEC_45P3of3yabm7cvkRh3aQg2ttgsdxVJcMeta } from "/tmp/build_2f948bb8/pages/app/onboarding/profiles.vue?macro=true";
import { default as membershipi7SQMbW_45Iua_9GNfC2RvMMn3ISjyBn35GH2tgc1qpDgMeta } from "/tmp/build_2f948bb8/pages/app/onboarding/membership.vue?macro=true";
import { default as permissionslZuHjFy4Pjt8HbcPwv3YawSRYmR0i_45zuBOwscnVXLDAMeta } from "/tmp/build_2f948bb8/pages/app/onboarding/permissions.vue?macro=true";
import { default as onboardingAK9jG4PpmJDAKfBEeE65Lisy3_VUQUmgWLYJ_Qy6hRMMeta } from "/tmp/build_2f948bb8/pages/app/onboarding.vue?macro=true";
import { default as investors7Q5BhsQGiv87TMTyYEzFaYQLoG5hbBN2v9rG_45dYWRTQMeta } from "/tmp/build_2f948bb8/pages/main/investors.vue?macro=true";
import { default as _91id_938Os4y5j0uA5XJaOCa7NwA0DdLPO_452A87RO9_I_45vg8scMeta } from "/tmp/build_2f948bb8/pages/admin/blog/[id].vue?macro=true";
import { default as broadcast12WeS4795khgm4sb7sxbHv_Q7lOJEHWHdUyexmxopSoMeta } from "/tmp/build_2f948bb8/pages/admin/broadcast.vue?macro=true";
import { default as deleteyra_aAQzvL_7doOk45O6KsURFdXFEV3dcmbbXWBX9GEMeta } from "/tmp/build_2f948bb8/pages/app/auth/delete.vue?macro=true";
import { default as logoutk9r8DmDN_rqkLBuS0uf4beYeIC1hPPkC7SBDvfziuXoMeta } from "/tmp/build_2f948bb8/pages/app/auth/logout.vue?macro=true";
import { default as indexUV5PvXNPB3dJBS6mZNaMco6RJ0Vk5P6Bz7kvHU_45MvloMeta } from "/tmp/build_2f948bb8/pages/app/story/index.vue?macro=true";
import { default as index9VqJk7kbFVTocLsOaQT44PtwKt_45m3tzb_45B0kZ1w3g84Meta } from "/tmp/build_2f948bb8/pages/backstage/index.vue?macro=true";
import { default as indexlb2_4576Nq4UfkwfmDVPuuaOX5j7N3km8a_6rE1pd_Ls4Meta } from "/tmp/build_2f948bb8/pages/main/auth/index.vue?macro=true";
import { default as index9MuHxZ0_45T_45tp0BBcLSSbSf00cFJQ3GTVonXgSiNrRwQMeta } from "/tmp/build_2f948bb8/pages/main/blog/index.vue?macro=true";
import { default as indexJSwFtfG1BxguEaafYWakQldPJfSQsSJqQfr07soM8NsMeta } from "/tmp/build_2f948bb8/pages/admin/auth/index.vue?macro=true";
import { default as indexksQc1ARwgMDjv8UadKnhuVMUe52Tiil5L8xi1fEwvpQMeta } from "/tmp/build_2f948bb8/pages/admin/blog/index.vue?macro=true";
import { default as deleteQ_45sFM5IwLuWyMGX_45XqqYv3iBrgPjx50zrTXhusnCrJsMeta } from "/tmp/build_2f948bb8/pages/main/auth/delete.vue?macro=true";
import { default as _91slug_93sEAvY4Ryw9KdWwfph5cp_nVKFNFX1_ilJ_VlPhq_jcoMeta } from "/tmp/build_2f948bb8/pages/main/blog/[slug].vue?macro=true";
import { default as indexh5T5Hq30K5kxwnQV41tvSpA9QQhrMosbLzOT3M8zxZAMeta } from "/tmp/build_2f948bb8/pages/main/event/index.vue?macro=true";
import { default as _91token_93ZzbjwVEeUAIyuLzAzRjdqLC_45rOSw4yK7YcOYLY5BKu0Meta } from "/tmp/build_2f948bb8/pages/payments/[token].vue?macro=true";
import { default as edit1nspmZHBcU4eTBV1oG67u8qvpsZJGKi8jiY19bW9i98Meta } from "/tmp/build_2f948bb8/pages/app/events/[slug]/edit.vue?macro=true";
import { default as indexSQc_aHA6TQ_rR29BN_kkzZSvK3bh_NvgOLe9FYeaHukMeta } from "/tmp/build_2f948bb8/pages/app/events/[slug]/index.vue?macro=true";
import { default as _91slug_93qgQBZQmA9DEsUapfYqmONK_4503gAVCZPpJt3HBsdCShIMeta } from "/tmp/build_2f948bb8/pages/app/events/[slug].vue?macro=true";
import { default as createmdVP7bCPSqNewAJDes06ebQxUZahIfvKyT_456eWuMMQEMeta } from "/tmp/build_2f948bb8/pages/app/events/create.vue?macro=true";
import { default as listJ5sNaQiVUTZ7niH3K0dQagI2KyZd6jAW_xKlZ0Ap8YYMeta } from "/tmp/build_2f948bb8/pages/app/partners/list.vue?macro=true";
import { default as _91slug_93KKt_45eeOnamrClfIgzvn_454Zfz0CrpVfDkQKF68cvmxRQMeta } from "/tmp/build_2f948bb8/pages/main/event/[slug].vue?macro=true";
import { default as _91slug_93Rz_45SgPYz1d6R_45XXxQ8LDH3W4rrWQRhAHw0M_45T_AuwIMMeta } from "/tmp/build_2f948bb8/pages/main/group/[slug].vue?macro=true";
import { default as _91slug_93e8ZmQp3dsXyzrZok_K8beUhrh0RstzxrT3lskeRutRMMeta } from "/tmp/build_2f948bb8/pages/main/place/[slug].vue?macro=true";
import { default as _91city_93SnKYplw5v_7lvXqRQUKGygmYMlmebkfQrIRqqZLkoSsMeta } from "/tmp/build_2f948bb8/pages/main/cities/[city].vue?macro=true";
import { default as _91slug_93mjzYYcpQtt5PKzlPmBE6uRumkHgqcbat2k1UJzo5oqsMeta } from "/tmp/build_2f948bb8/pages/main/invite/[slug].vue?macro=true";
import { default as organizationsTp9a0MRlnJMzGCaT_45v0QhUYDEMR6HLmBHKAKUtPHFC0Meta } from "/tmp/build_2f948bb8/pages/admin/organizations.vue?macro=true";
import { default as indexie33TVrwhRaPK203KGDGwVFnx20TMS1fINNsBCAstgYMeta } from "/tmp/build_2f948bb8/pages/admin/reports/index.vue?macro=true";
import { default as eventsZ1YQEoUzLVhNFpkG_mKlDQYHI_1wSym3t2NU6MXu_tQMeta } from "/tmp/build_2f948bb8/pages/admin/reports/events.vue?macro=true";
import { default as preferencess9s2zzfOoJtMEEqpk55i40dDPGUiezYErh7O1hFWQ_45EMeta } from "/tmp/build_2f948bb8/pages/app/auth/preferences.vue?macro=true";
import { default as login6wfQy3Audwfq2luwxT6AvzVjJo4db1UmKeO_45Qr0DLesMeta } from "/tmp/build_2f948bb8/pages/backstage/auth/login.vue?macro=true";
import { default as _91id_93AYux_l6y_45XAqoVgQ_CxHOFrzwitZwcauczOUyYyf6GsMeta } from "/tmp/build_2f948bb8/pages/app/conversation/[id].vue?macro=true";
import { default as logoutQpFx__45XwE7YbZWHM64yGp40t5v06Dh5Tn926NAftfOYMeta } from "/tmp/build_2f948bb8/pages/backstage/auth/logout.vue?macro=true";
import { default as preferencesJoViGkAOasHxnqyZ5xKT6I9xCKs4JQAp_45BiSpB7OLGsMeta } from "/tmp/build_2f948bb8/pages/main/auth/preferences.vue?macro=true";
import { default as list7WB5D6C8p7JSIkdjdJzu1Q4w6zi_jr6X97bcOg7VuKkMeta } from "/tmp/build_2f948bb8/pages/app/organizations/list.vue?macro=true";
import { default as _91token_93y92pgUz4HStDCdmk3tLCmEWxL_vZ8ugrqeRqZjZoTBwMeta } from "/tmp/build_2f948bb8/pages/app/auth/verify/[token].vue?macro=true";
import { default as registeriSN76_0g_45q3OIjtf7BqMklTG8QEue2rBbhdrTD9rsHgMeta } from "/tmp/build_2f948bb8/pages/backstage/auth/register.vue?macro=true";
import { default as _91code_93_45bxVH_yVmyDIRXiTIR4LtdHs6ZxUemCoxKiM8pZj5tgMeta } from "/tmp/build_2f948bb8/pages/backstage/invite/[code].vue?macro=true";
import { default as discord07_CHi_45DgObiyvvAPL_45FdC_45H1ke_45zH91uVOMT_OfgkEMeta } from "/tmp/build_2f948bb8/pages/app/integrations/discord.vue?macro=true";
import { default as indexYOmqy6cCcUny1nT7pJCapDL21ZPVot_XDCJX0vBdEDgMeta } from "/tmp/build_2f948bb8/pages/backstage/dashboard/index.vue?macro=true";
import { default as questions_45frequentesllvZ5CQd1FC4zWc0eud2Gu_1KO0zbFEm9PDuUCWSyx8Meta } from "/tmp/build_2f948bb8/pages/main/questions-frequentes.vue?macro=true";
import { default as discord_45authnfT93shP4XCbhPWnOYVdbb3spnt6FWEjLg80niDeXusMeta } from "/tmp/build_2f948bb8/pages/app/integrations/discord-auth.vue?macro=true";
import { default as subscribe39HHdi6fVDNUDhhXM8dCkmkVTH2FSFmHfTeV0LqQjscMeta } from "/tmp/build_2f948bb8/pages/backstage/dashboard/subscribe.vue?macro=true";
import { default as indexWZ39dxwvuiOnpiGFXCZ108HUHDogjjk8Pt9tJ9dMflQMeta } from "/tmp/build_2f948bb8/pages/backstage/dashboard/events/index.vue?macro=true";
import { default as indexCmzT3yamAZtej8Kjj6WYDgR0PHKJrWaHW_sbxNB35W8Meta } from "/tmp/build_2f948bb8/pages/backstage/dashboard/places/index.vue?macro=true";
import { default as indexoZ3Xq6XSa_jkDFlJvyJ1XbqID0IZ8pD6hC2UWdd3aoYMeta } from "/tmp/build_2f948bb8/pages/backstage/dashboard/events/[slug]/edit/index.vue?macro=true";
import { default as detailsx9stvPMmETzYj36lE_EqzlN3s_45m4hOmEOXsP3ghz_45nQMeta } from "/tmp/build_2f948bb8/pages/backstage/dashboard/events/[slug]/edit/details.vue?macro=true";
import { default as advancedLs01k0lKhIR0XLu2lCQE_zmwWICZ0TcXAtoKmloGxbQMeta } from "/tmp/build_2f948bb8/pages/backstage/dashboard/events/[slug]/edit/advanced.vue?macro=true";
import { default as attendeesBmI5rtx7ppiCcZldt_qLc3O_JqkBczppN4t9LoueoHcMeta } from "/tmp/build_2f948bb8/pages/backstage/dashboard/events/[slug]/edit/attendees.vue?macro=true";
import { default as editcxDdKnBVzPQ5K48jmyjH5x18BOv0ToCymkPbVx_45KShUMeta } from "/tmp/build_2f948bb8/pages/backstage/dashboard/events/[slug]/edit.vue?macro=true";
import { default as index4Q2mhlsUAbrxsRJ2I_ON845vq1GJsP4k5hxkBJyMzY4Meta } from "/tmp/build_2f948bb8/pages/backstage/dashboard/events/[slug]/index.vue?macro=true";
import { default as attendeesNwxPYk2p7D_JIWIqhaoYABIkHVVT5wnORqyGmG7mrL8Meta } from "/tmp/build_2f948bb8/pages/backstage/dashboard/events/[slug]/attendees.vue?macro=true";
import { default as _91slug_93Hwxrj63uK8H3o_SgdVjZnKbs_45u3gkv1eo9EG1kHB5rcMeta } from "/tmp/build_2f948bb8/pages/backstage/dashboard/events/[slug].vue?macro=true";
import { default as create10E8A8tZ6GTbRMlEY0INI0fAtNM5aWgs6AUSpsqX2eYMeta } from "/tmp/build_2f948bb8/pages/backstage/dashboard/events/create.vue?macro=true";
import { default as indexSWB2oOwXYY_45iihD6XbX8co2kpG704Tvorotn89XNAFYMeta } from "/tmp/build_2f948bb8/pages/backstage/dashboard/settings/index.vue?macro=true";
import { default as indexFG16I42s3RF0gC8wURexGr_45_45EG0EWmjKNfzhWX5iREwMeta } from "/tmp/build_2f948bb8/pages/backstage/dashboard/organization/index.vue?macro=true";
import { default as component_45stub1qVIVIyl4JenXxgzJyT00wTJvNMLcMinsj_Vazxt3m0Meta } from "/tmp/build_2f948bb8/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub1qVIVIyl4JenXxgzJyT00wTJvNMLcMinsj_Vazxt3m0 } from "/tmp/build_2f948bb8/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: meDQZ0e_JU7gviYiuEkZMZbF0HR5h2fFBwZXQ_45QJCbHnQMeta?.name,
    path: "/app/me",
    meta: meDQZ0e_JU7gviYiuEkZMZbF0HR5h2fFBwZXQ_45QJCbHnQMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/me.vue"),
    children: [
  {
    name: "app-me",
    path: "",
    component: () => import("/tmp/build_2f948bb8/pages/app/me/index.vue")
  }
]
  },
  {
    name: "app-map",
    path: "/app/map",
    meta: { ...(mapAJBgW9woa3YKMKjy48MC3HODAY4NnJOJ1fscFCBK4oIMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/map.vue")
  },
  {
    name: feed3w8LOPdd7UI8gNsuZ1EW1AzN0CiW7TesRcxU1nLinzsMeta?.name,
    path: "/app/feed",
    meta: { ...(feed3w8LOPdd7UI8gNsuZ1EW1AzN0CiW7TesRcxU1nLinzsMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/feed.vue"),
    children: [
  {
    name: "app-feed-post",
    path: "post",
    meta: postdobwtjK6dfaucFCXnanv6HXDlUzR_JfbiH3Lwzy1VVQMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/feed/post.vue")
  },
  {
    name: "app-feed",
    path: "",
    meta: indexMeoJaXEdsiIy3foYHYSriZlDKr8Z1Lasa99vlYCCg_45MMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/feed/index.vue")
  },
  {
    name: "app-feed-type",
    path: ":type()",
    meta: _91type_93JpbgpSlNmyGHTYuZfFnz1wSVFPM9_dba3fhzHIWXgScMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/feed/[type].vue")
  }
]
  },
  {
    name: "app",
    path: "/app",
    meta: { ...(index4BthM0agDeEyhaYVLyRlGJq1g4Qugg6TzZKt8_kxMcUMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/index.vue")
  },
  {
    name: "main-eula",
    path: "/main/eula",
    meta: eula0fiaT_dR67au3vheXskYFfCDLlaT0gmwls77o0A7vOAMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/main/eula.vue")
  },
  {
    name: groups62tYVOxcrWxjQLmgUnnaPI9JroDs68UyBMO43Kzks3cMeta?.name,
    path: "/app/groups",
    meta: { ...(groups62tYVOxcrWxjQLmgUnnaPI9JroDs68UyBMO43Kzks3cMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/groups.vue"),
    children: [
  {
    name: "app-groups",
    path: "",
    component: () => import("/tmp/build_2f948bb8/pages/app/groups/index.vue")
  },
  {
    name: _91slug_935d_E63cJOSoEkm_FbICiYWqzsGigKdFCj7_45poEY6XGEMeta?.name,
    path: ":slug()",
    meta: _91slug_935d_E63cJOSoEkm_FbICiYWqzsGigKdFCj7_45poEY6XGEMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/groups/[slug].vue"),
    children: [
  {
    name: "app-groups-slug-edit",
    path: "edit",
    component: () => import("/tmp/build_2f948bb8/pages/app/groups/[slug]/edit.vue")
  },
  {
    name: "app-groups-slug-about",
    path: "about",
    component: () => import("/tmp/build_2f948bb8/pages/app/groups/[slug]/about.vue")
  },
  {
    name: "app-groups-slug",
    path: "",
    component: () => import("/tmp/build_2f948bb8/pages/app/groups/[slug]/index.vue")
  },
  {
    name: "app-groups-slug-events",
    path: "events",
    component: () => import("/tmp/build_2f948bb8/pages/app/groups/[slug]/events.vue")
  },
  {
    name: "app-groups-slug-members",
    path: "members",
    component: () => import("/tmp/build_2f948bb8/pages/app/groups/[slug]/members.vue")
  },
  {
    name: "app-groups-slug-conversations",
    path: "conversations",
    component: () => import("/tmp/build_2f948bb8/pages/app/groups/[slug]/conversations.vue")
  }
]
  },
  {
    name: "app-groups-create",
    path: "create",
    meta: createfKTUPh2MVuD3rVirItrx58z_45S2gQUtBfrl69PW7RAjcMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/groups/create.vue")
  }
]
  },
  {
    name: paramshGLAPmDqQmsBqQ3TXyGBOIDoEkFinuE_45dMo2FAUyHdMMeta?.name,
    path: "/app/params",
    meta: { ...(paramshGLAPmDqQmsBqQ3TXyGBOIDoEkFinuE_45dMo2FAUyHdMMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/params.vue"),
    children: [
  {
    name: "app-params",
    path: "",
    meta: { ...(index75fgToJ3omEUAzNNCWEPLPjD8U9ep_ncMhT6JccGOckMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/params/index.vue")
  },
  {
    name: "app-params-account",
    path: "account",
    meta: { ...(accountSwb5M70rVnZKudgCpuM7do6yMZIerjK6PJYfMxA3xqAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/params/account.vue")
  },
  {
    name: "app-params-transactions",
    path: "transactions",
    meta: { ...(transactionsrvmyuxO2tDrRY_45Cse_8P8dXQXcAb6AhzFlexjQOv2NAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/params/transactions.vue")
  }
]
  },
  {
    name: "main",
    path: "/main",
    meta: indexI8kPQwVb_45WMBFyfPTeB5FY4rlb3U7M5E_GBcLzWCjSAMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/main/index.vue")
  },
  {
    name: "main-press",
    path: "/main/press",
    meta: press6w1LKVKQvwG0GJzhE3M5JNUEbn9kb9ESha6H8wqpiroMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/main/press.vue")
  },
  {
    name: "admin-codes",
    path: "/admin/codes",
    meta: { ...(codes7xWT9EkaAWruLk_45T8RfOkYUVylVMZrlxf14Q_bGvTFUMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_2f948bb8/pages/admin/codes.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexJynwy786Zm3xHPUG_ImP93u6NoCd8rBOJD507JNtlX4Meta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_2f948bb8/pages/admin/index.vue")
  },
  {
    name: hangoutSz63weB1WxFmOXVUlPxHIDml2qBlxeRdbXCxbMMtndMMeta?.name,
    path: "/app/hangout",
    meta: { ...(hangoutSz63weB1WxFmOXVUlPxHIDml2qBlxeRdbXCxbMMtndMMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/hangout.vue"),
    children: [
  {
    name: "app-hangout",
    path: "",
    meta: indexlJi_45WuxP0z9_45u_45eDD_45QEmlr_45PKGczuKkHl_edbNEbbIMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/hangout/index.vue")
  },
  {
    name: "app-hangout-agenda",
    path: "agenda",
    meta: { ...(agendaGiA62ukj6MrRVHrunTsZQh549_45JEMWdBzMl0xtfYNrwMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/hangout/agenda.vue")
  },
  {
    name: "app-hangout-meetups",
    path: "meetups",
    meta: meetups8vSNl2d3j1Sk4qeTb42a_45rnBcdeDpNloqcks23GrDgYMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/hangout/meetups.vue")
  },
  {
    name: "app-hangout-organize",
    path: "organize",
    meta: { ...(organizeTRYUTe61IDLRNj1nSp93KSL9Sh2p0XOEfEeDBc9hswYMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/hangout/organize.vue")
  }
]
  },
  {
    name: "main-charte",
    path: "/main/charte",
    meta: chartex8ZpudX39Y35SLtnUAvb6mp70nmGaqEluxH4O_m3zMEMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/main/charte.vue")
  },
  {
    name: "main-france",
    path: "/main/france",
    meta: france2a70q2zLdh0cH_SYFo_scQBMZaiRljlrHmcX8wbawuIMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/main/france.vue")
  },
  {
    name: "admin-themes",
    path: "/admin/themes",
    meta: { ...(themes9xKmzzE_45HjIdlgtUDeNNwC1hqCUdBROSfMn4p_45oJIjAMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_2f948bb8/pages/admin/themes.vue")
  },
  {
    name: insidersx_45WCfSuoTMnShIxmKucXyZutgHaVzwaf8i4eMWh4fD4Meta?.name,
    path: "/app/insiders",
    meta: { ...(insidersx_45WCfSuoTMnShIxmKucXyZutgHaVzwaf8i4eMWh4fD4Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/insiders.vue"),
    children: [
  {
    name: "app-insiders",
    path: "",
    component: () => import("/tmp/build_2f948bb8/pages/app/insiders/index.vue")
  },
  {
    name: "app-insiders-suggestions",
    path: "suggestions",
    meta: suggestionspWvtkKryw_akM385fHpgpyBK8RERBUMo4TaGd1ba9_45UMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/insiders/suggestions.vue")
  }
]
  },
  {
    name: "app-messages",
    path: "/app/messages",
    meta: { ...(messageslIG5g5EuFxbXYDvQAix9QkmGP4GxxK4Qy5f9cORjH74Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/messages.vue")
  },
  {
    name: "main-privacy",
    path: "/main/privacy",
    meta: privacyS7CSltRzOze4AmxcfwLovlo3mTSfumWDIOANZrGO_7IMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/main/privacy.vue")
  },
  {
    name: "admin-trainer",
    path: "/admin/trainer",
    meta: { ...(trainerqihrbh1O8ViVEPiAFY8j6dA3fDJYd6_4548tgufGWpLPsMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_2f948bb8/pages/admin/trainer.vue")
  },
  {
    name: community8_HVM3vuTQ28W6PaPwPJMDWZg2y_450DtO_D98KWPVxJAMeta?.name,
    path: "/app/community",
    meta: { ...(community8_HVM3vuTQ28W6PaPwPJMDWZg2y_450DtO_D98KWPVxJAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/community.vue"),
    children: [
  {
    name: "app-community",
    path: "",
    meta: indexELIesie44XR2rbWaJxVomwVhX6Rm2NI_45t7JhLPRQuC8Meta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/community/index.vue")
  },
  {
    name: "app-community-search",
    path: "search",
    meta: searchMy_45Z4QcbR3oVL5WLtOvnfaeG0IWQqZCslsTxz0wgFlcMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/community/search.vue")
  },
  {
    name: "app-community-besties",
    path: "besties",
    meta: { ...(bestiesQAnMTV_45KRRXGSpv_45SyJzixoOdjtNFktKIsI9wRFfE2IMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/community/besties.vue")
  },
  {
    name: "app-community-type",
    path: ":type()",
    meta: { ...(indexalJNUqT64H6SSHA2XB18vLzIWzLR758QmmuVFD7vlkAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/community/[type]/index.vue")
  }
]
  },
  {
    name: "app-auth",
    path: "/app/auth",
    meta: { ...(indexM5znqnFJE5Isjojr6seM5F5hfcT5TK4jDbeFWz7JrwQMeta || {}), ...{"middleware":["is-not-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/auth/index.vue")
  },
  {
    name: onboardingAK9jG4PpmJDAKfBEeE65Lisy3_VUQUmgWLYJ_Qy6hRMMeta?.name,
    path: "/app/onboarding",
    meta: { ...(onboardingAK9jG4PpmJDAKfBEeE65Lisy3_VUQUmgWLYJ_Qy6hRMMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/onboarding.vue"),
    children: [
  {
    name: "app-onboarding-about",
    path: "about",
    component: () => import("/tmp/build_2f948bb8/pages/app/onboarding/about.vue")
  },
  {
    name: "app-onboarding-email",
    path: "email",
    component: () => import("/tmp/build_2f948bb8/pages/app/onboarding/email.vue")
  },
  {
    name: "app-onboarding-goals",
    path: "goals",
    component: () => import("/tmp/build_2f948bb8/pages/app/onboarding/goals.vue")
  },
  {
    name: "app-onboarding",
    path: "",
    meta: indexGrvS7Wqczeqluciioc3VCJo0zcRjkXgweS_j846VV8wMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/onboarding/index.vue")
  },
  {
    name: "app-onboarding-phone",
    path: "phone",
    component: () => import("/tmp/build_2f948bb8/pages/app/onboarding/phone.vue")
  },
  {
    name: "app-onboarding-groups",
    path: "groups",
    component: () => import("/tmp/build_2f948bb8/pages/app/onboarding/groups.vue")
  },
  {
    name: "app-onboarding-search",
    path: "search",
    component: () => import("/tmp/build_2f948bb8/pages/app/onboarding/search.vue")
  },
  {
    name: "app-onboarding-charter",
    path: "charter",
    component: () => import("/tmp/build_2f948bb8/pages/app/onboarding/charter.vue")
  },
  {
    name: "app-onboarding-loading",
    path: "loading",
    component: () => import("/tmp/build_2f948bb8/pages/app/onboarding/loading.vue")
  },
  {
    name: "app-onboarding-profile",
    path: "profile",
    component: () => import("/tmp/build_2f948bb8/pages/app/onboarding/profile.vue")
  },
  {
    name: "app-onboarding-identity",
    path: "identity",
    component: () => import("/tmp/build_2f948bb8/pages/app/onboarding/identity.vue")
  },
  {
    name: "app-onboarding-profiles",
    path: "profiles",
    component: () => import("/tmp/build_2f948bb8/pages/app/onboarding/profiles.vue")
  },
  {
    name: "app-onboarding-membership",
    path: "membership",
    component: () => import("/tmp/build_2f948bb8/pages/app/onboarding/membership.vue")
  },
  {
    name: "app-onboarding-permissions",
    path: "permissions",
    component: () => import("/tmp/build_2f948bb8/pages/app/onboarding/permissions.vue")
  }
]
  },
  {
    name: "main-investors",
    path: "/main/investors",
    meta: investors7Q5BhsQGiv87TMTyYEzFaYQLoG5hbBN2v9rG_45dYWRTQMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/main/investors.vue")
  },
  {
    name: "admin-blog-id",
    path: "/admin/blog/:id()",
    meta: { ...(_91id_938Os4y5j0uA5XJaOCa7NwA0DdLPO_452A87RO9_I_45vg8scMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_2f948bb8/pages/admin/blog/[id].vue")
  },
  {
    name: "admin-broadcast",
    path: "/admin/broadcast",
    meta: { ...(broadcast12WeS4795khgm4sb7sxbHv_Q7lOJEHWHdUyexmxopSoMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_2f948bb8/pages/admin/broadcast.vue")
  },
  {
    name: "app-auth-delete",
    path: "/app/auth/delete",
    meta: deleteyra_aAQzvL_7doOk45O6KsURFdXFEV3dcmbbXWBX9GEMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/auth/delete.vue")
  },
  {
    name: "app-auth-logout",
    path: "/app/auth/logout",
    meta: logoutk9r8DmDN_rqkLBuS0uf4beYeIC1hPPkC7SBDvfziuXoMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/auth/logout.vue")
  },
  {
    name: "app-story",
    path: "/app/story",
    meta: { ...(indexUV5PvXNPB3dJBS6mZNaMco6RJ0Vk5P6Bz7kvHU_45MvloMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/story/index.vue")
  },
  {
    name: "backstage",
    path: "/backstage",
    meta: { ...(index9VqJk7kbFVTocLsOaQT44PtwKt_45m3tzb_45B0kZ1w3g84Meta || {}), ...{"middleware":["backstage-auth"]} },
    component: () => import("/tmp/build_2f948bb8/pages/backstage/index.vue")
  },
  {
    name: "main-auth",
    path: "/main/auth",
    component: () => import("/tmp/build_2f948bb8/pages/main/auth/index.vue")
  },
  {
    name: "main-blog",
    path: "/main/blog",
    meta: index9MuHxZ0_45T_45tp0BBcLSSbSf00cFJQ3GTVonXgSiNrRwQMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/main/blog/index.vue")
  },
  {
    name: "admin-auth",
    path: "/admin/auth",
    meta: indexJSwFtfG1BxguEaafYWakQldPJfSQsSJqQfr07soM8NsMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/admin/auth/index.vue")
  },
  {
    name: "admin-blog",
    path: "/admin/blog",
    meta: { ...(indexksQc1ARwgMDjv8UadKnhuVMUe52Tiil5L8xi1fEwvpQMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_2f948bb8/pages/admin/blog/index.vue")
  },
  {
    name: "main-auth-delete",
    path: "/main/auth/delete",
    component: () => import("/tmp/build_2f948bb8/pages/main/auth/delete.vue")
  },
  {
    name: "main-blog-slug",
    path: "/main/blog/:slug()",
    meta: _91slug_93sEAvY4Ryw9KdWwfph5cp_nVKFNFX1_ilJ_VlPhq_jcoMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/main/blog/[slug].vue")
  },
  {
    name: "main-event",
    path: "/main/event",
    meta: indexh5T5Hq30K5kxwnQV41tvSpA9QQhrMosbLzOT3M8zxZAMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/main/event/index.vue")
  },
  {
    name: "payments-token",
    path: "/payments/:token()",
    meta: _91token_93ZzbjwVEeUAIyuLzAzRjdqLC_45rOSw4yK7YcOYLY5BKu0Meta || {},
    component: () => import("/tmp/build_2f948bb8/pages/payments/[token].vue")
  },
  {
    name: _91slug_93qgQBZQmA9DEsUapfYqmONK_4503gAVCZPpJt3HBsdCShIMeta?.name,
    path: "/app/events/:slug()",
    meta: { ...(_91slug_93qgQBZQmA9DEsUapfYqmONK_4503gAVCZPpJt3HBsdCShIMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/events/[slug].vue"),
    children: [
  {
    name: "app-events-slug-edit",
    path: "edit",
    meta: edit1nspmZHBcU4eTBV1oG67u8qvpsZJGKi8jiY19bW9i98Meta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/events/[slug]/edit.vue")
  },
  {
    name: "app-events-slug",
    path: "",
    component: () => import("/tmp/build_2f948bb8/pages/app/events/[slug]/index.vue")
  }
]
  },
  {
    name: "app-events-create",
    path: "/app/events/create",
    meta: { ...(createmdVP7bCPSqNewAJDes06ebQxUZahIfvKyT_456eWuMMQEMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/events/create.vue")
  },
  {
    name: "app-partners-list",
    path: "/app/partners/list",
    meta: { ...(listJ5sNaQiVUTZ7niH3K0dQagI2KyZd6jAW_xKlZ0Ap8YYMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/partners/list.vue")
  },
  {
    name: "main-event-slug",
    path: "/main/event/:slug()",
    meta: _91slug_93KKt_45eeOnamrClfIgzvn_454Zfz0CrpVfDkQKF68cvmxRQMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/main/event/[slug].vue")
  },
  {
    name: "main-group-slug",
    path: "/main/group/:slug()",
    meta: _91slug_93Rz_45SgPYz1d6R_45XXxQ8LDH3W4rrWQRhAHw0M_45T_AuwIMMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/main/group/[slug].vue")
  },
  {
    name: "main-place-slug",
    path: "/main/place/:slug()",
    meta: _91slug_93e8ZmQp3dsXyzrZok_K8beUhrh0RstzxrT3lskeRutRMMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/main/place/[slug].vue")
  },
  {
    name: "main-cities-city",
    path: "/main/cities/:city()",
    meta: _91city_93SnKYplw5v_7lvXqRQUKGygmYMlmebkfQrIRqqZLkoSsMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/main/cities/[city].vue")
  },
  {
    name: "main-invite-slug",
    path: "/main/invite/:slug()",
    component: () => import("/tmp/build_2f948bb8/pages/main/invite/[slug].vue")
  },
  {
    name: "admin-organizations",
    path: "/admin/organizations",
    meta: { ...(organizationsTp9a0MRlnJMzGCaT_45v0QhUYDEMR6HLmBHKAKUtPHFC0Meta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_2f948bb8/pages/admin/organizations.vue")
  },
  {
    name: "admin-reports",
    path: "/admin/reports",
    meta: { ...(indexie33TVrwhRaPK203KGDGwVFnx20TMS1fINNsBCAstgYMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_2f948bb8/pages/admin/reports/index.vue")
  },
  {
    name: "admin-reports-events",
    path: "/admin/reports/events",
    meta: { ...(eventsZ1YQEoUzLVhNFpkG_mKlDQYHI_1wSym3t2NU6MXu_tQMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_2f948bb8/pages/admin/reports/events.vue")
  },
  {
    name: "app-auth-preferences",
    path: "/app/auth/preferences",
    meta: preferencess9s2zzfOoJtMEEqpk55i40dDPGUiezYErh7O1hFWQ_45EMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/auth/preferences.vue")
  },
  {
    name: "backstage-auth-login",
    path: "/backstage/auth/login",
    meta: login6wfQy3Audwfq2luwxT6AvzVjJo4db1UmKeO_45Qr0DLesMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/backstage/auth/login.vue")
  },
  {
    name: "app-conversation-id",
    path: "/app/conversation/:id()",
    meta: { ...(_91id_93AYux_l6y_45XAqoVgQ_CxHOFrzwitZwcauczOUyYyf6GsMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/conversation/[id].vue")
  },
  {
    name: "backstage-auth-logout",
    path: "/backstage/auth/logout",
    meta: logoutQpFx__45XwE7YbZWHM64yGp40t5v06Dh5Tn926NAftfOYMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/backstage/auth/logout.vue")
  },
  {
    name: "main-auth-preferences",
    path: "/main/auth/preferences",
    component: () => import("/tmp/build_2f948bb8/pages/main/auth/preferences.vue")
  },
  {
    name: "app-organizations-list",
    path: "/app/organizations/list",
    meta: { ...(list7WB5D6C8p7JSIkdjdJzu1Q4w6zi_jr6X97bcOg7VuKkMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/app/organizations/list.vue")
  },
  {
    name: "app-auth-verify-token",
    path: "/app/auth/verify/:token()",
    meta: _91token_93y92pgUz4HStDCdmk3tLCmEWxL_vZ8ugrqeRqZjZoTBwMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/auth/verify/[token].vue")
  },
  {
    name: "backstage-auth-register",
    path: "/backstage/auth/register",
    meta: registeriSN76_0g_45q3OIjtf7BqMklTG8QEue2rBbhdrTD9rsHgMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/backstage/auth/register.vue")
  },
  {
    name: "backstage-invite-code",
    path: "/backstage/invite/:code()",
    meta: _91code_93_45bxVH_yVmyDIRXiTIR4LtdHs6ZxUemCoxKiM8pZj5tgMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/backstage/invite/[code].vue")
  },
  {
    name: "app-integrations-discord",
    path: "/app/integrations/discord",
    meta: discord07_CHi_45DgObiyvvAPL_45FdC_45H1ke_45zH91uVOMT_OfgkEMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/integrations/discord.vue")
  },
  {
    name: "backstage-dashboard",
    path: "/backstage/dashboard",
    meta: { ...(indexYOmqy6cCcUny1nT7pJCapDL21ZPVot_XDCJX0vBdEDgMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/backstage/dashboard/index.vue")
  },
  {
    name: "main-questions-frequentes",
    path: "/main/questions-frequentes",
    meta: questions_45frequentesllvZ5CQd1FC4zWc0eud2Gu_1KO0zbFEm9PDuUCWSyx8Meta || {},
    component: () => import("/tmp/build_2f948bb8/pages/main/questions-frequentes.vue")
  },
  {
    name: "app-integrations-discord-auth",
    path: "/app/integrations/discord-auth",
    meta: discord_45authnfT93shP4XCbhPWnOYVdbb3spnt6FWEjLg80niDeXusMeta || {},
    component: () => import("/tmp/build_2f948bb8/pages/app/integrations/discord-auth.vue")
  },
  {
    name: "backstage-dashboard-subscribe",
    path: "/backstage/dashboard/subscribe",
    meta: { ...(subscribe39HHdi6fVDNUDhhXM8dCkmkVTH2FSFmHfTeV0LqQjscMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/backstage/dashboard/subscribe.vue")
  },
  {
    name: "backstage-dashboard-events",
    path: "/backstage/dashboard/events",
    meta: { ...(indexWZ39dxwvuiOnpiGFXCZ108HUHDogjjk8Pt9tJ9dMflQMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/backstage/dashboard/events/index.vue")
  },
  {
    name: "backstage-dashboard-places",
    path: "/backstage/dashboard/places",
    meta: { ...(indexCmzT3yamAZtej8Kjj6WYDgR0PHKJrWaHW_sbxNB35W8Meta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/backstage/dashboard/places/index.vue")
  },
  {
    name: _91slug_93Hwxrj63uK8H3o_SgdVjZnKbs_45u3gkv1eo9EG1kHB5rcMeta?.name,
    path: "/backstage/dashboard/events/:slug()",
    component: () => import("/tmp/build_2f948bb8/pages/backstage/dashboard/events/[slug].vue"),
    children: [
  {
    name: editcxDdKnBVzPQ5K48jmyjH5x18BOv0ToCymkPbVx_45KShUMeta?.name,
    path: "edit",
    meta: { ...(editcxDdKnBVzPQ5K48jmyjH5x18BOv0ToCymkPbVx_45KShUMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/backstage/dashboard/events/[slug]/edit.vue"),
    children: [
  {
    name: "backstage-dashboard-events-slug-edit",
    path: "",
    component: () => import("/tmp/build_2f948bb8/pages/backstage/dashboard/events/[slug]/edit/index.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-details",
    path: "details",
    component: () => import("/tmp/build_2f948bb8/pages/backstage/dashboard/events/[slug]/edit/details.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-advanced",
    path: "advanced",
    component: () => import("/tmp/build_2f948bb8/pages/backstage/dashboard/events/[slug]/edit/advanced.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-attendees",
    path: "attendees",
    component: () => import("/tmp/build_2f948bb8/pages/backstage/dashboard/events/[slug]/edit/attendees.vue")
  }
]
  },
  {
    name: "backstage-dashboard-events-slug",
    path: "",
    meta: { ...(index4Q2mhlsUAbrxsRJ2I_ON845vq1GJsP4k5hxkBJyMzY4Meta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/backstage/dashboard/events/[slug]/index.vue")
  },
  {
    name: "backstage-dashboard-events-slug-attendees",
    path: "attendees",
    meta: { ...(attendeesNwxPYk2p7D_JIWIqhaoYABIkHVVT5wnORqyGmG7mrL8Meta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/backstage/dashboard/events/[slug]/attendees.vue")
  }
]
  },
  {
    name: "backstage-dashboard-events-create",
    path: "/backstage/dashboard/events/create",
    meta: { ...(create10E8A8tZ6GTbRMlEY0INI0fAtNM5aWgs6AUSpsqX2eYMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/backstage/dashboard/events/create.vue")
  },
  {
    name: "backstage-dashboard-settings",
    path: "/backstage/dashboard/settings",
    meta: { ...(indexSWB2oOwXYY_45iihD6XbX8co2kpG704Tvorotn89XNAFYMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/backstage/dashboard/settings/index.vue")
  },
  {
    name: "backstage-dashboard-organization",
    path: "/backstage/dashboard/organization",
    meta: { ...(indexFG16I42s3RF0gC8wURexGr_45_45EG0EWmjKNfzhWX5iREwMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_2f948bb8/pages/backstage/dashboard/organization/index.vue")
  },
  {
    name: component_45stub1qVIVIyl4JenXxgzJyT00wTJvNMLcMinsj_Vazxt3m0Meta?.name,
    path: "/sitemap.xml",
    component: component_45stub1qVIVIyl4JenXxgzJyT00wTJvNMLcMinsj_Vazxt3m0
  }
]